import { Dictionary } from "../../../util/collection/Dictionary";
import { Sound } from "./Sound";
import { SoundParameter } from "./SoundParameter";
export class SoundChannel {
    constructor(globalVolume) {
        this.globalVolume = globalVolume;
        this.create();
    }
    create() {
        this.createSounds();
        this.setVolume(1);
    }
    createSounds() {
        this.muted = false;
        this.cachedSounds = new Dictionary();
        this.playingSounds = new Dictionary();
    }
    preloadSound(url, properties, loadHandler) {
        let cachedSounds = this.getCachedSounds(properties.name);
        let sound = this.createSound(url, properties, loadHandler, this.cleanUpCompletedSound);
        cachedSounds.push(sound);
    }
    unloadSound(properties) {
        let name = properties.name;
        let playingSounds = this.getPlayingSounds(name);
        for (let i = 0; i < playingSounds.length; i++) {
            this.stopSound(properties);
        }
        let cachedSounds = this.getCachedSounds(name);
        for (let sound of cachedSounds) {
            sound.unload();
        }
        this.cachedSounds.remove(name);
    }
    playSound(url, properties) {
        let sound;
        if (this.volume > 0) {
            let cachedSounds = this.getCachedSounds(properties.name);
            let playingSounds = this.getPlayingSounds(properties.name);
            if (cachedSounds.length > 0) {
                sound = cachedSounds.shift();
            }
            else {
                sound = this.createSound(url, properties, null, this.cleanUpCompletedSound);
            }
            sound.mute(this.muted);
            sound.volume(this.volume);
            sound.play();
            playingSounds.push(sound);
        }
        return sound;
    }
    stopSound(properties) {
        if (this.playingSounds.containsKey(properties.name)) {
            let playingSounds = this.getPlayingSounds(properties.name);
            let cachedSounds = this.getCachedSounds(properties.name);
            if (playingSounds.length > 0) {
                let sound = playingSounds.shift();
                sound.stop();
                cachedSounds.push(sound);
            }
        }
    }
    fadeSound(properties, toVolume = 0, durationMs = 1000) {
        if (this.playingSounds.containsKey(properties.name)) {
            let playingSounds = this.getPlayingSounds(properties.name);
            if (playingSounds.length > 0) {
                let sound = playingSounds.shift();
                sound.fade(sound.volume(), toVolume, durationMs, null);
            }
        }
    }
    mute() {
        this.muted = true;
        this.muteSounds();
    }
    unmute() {
        this.muted = false;
        this.muteSounds();
    }
    muteAllSounds(sounds) {
        sounds.map(function (sound) {
            sound.mute(this.muted);
        }, this);
        return sounds;
    }
    muteSounds() {
        let playingSounds = this.playingSounds.getValues();
        playingSounds.map(this.muteAllSounds, this);
    }
    setVolume(volume) {
        this.channelVolume = volume;
        if (!this.muted) {
            this.updateVolume();
            this.updateSounds();
        }
    }
    getVolume() {
        return this.volume;
    }
    updateVolume() {
        this.volume = this.globalVolume * this.channelVolume;
    }
    updateSounds() {
        let playingSounds = this.playingSounds.getValues();
        playingSounds.map(this.updateSoundsInArray, this);
    }
    updateSoundsInArray(sounds) {
        sounds.map(function (sound) {
            sound.volume(this.volume);
        }, this);
        return sounds;
    }
    /**
     * Removes completed sound from list of playing sounds and caches it for later.
     * @param id - The number id of the sound
     * @param properties - The properties of the sound
     */
    cleanUpCompletedSound(id, properties) {
        // this will be called on each repetition of a looping sound
        // the looping sound will need to be manually stopped and should be cleaned up then
        if (properties.loop)
            return;
        if (!this.playingSounds.containsKey(properties.name))
            return;
        const playingSounds = this.getPlayingSounds(properties.name);
        const cachedSounds = this.getCachedSounds(properties.name);
        const soundIndex = playingSounds.findIndex((sound) => sound["id"] === id);
        if (soundIndex === -1)
            return;
        cachedSounds.push(playingSounds[soundIndex]);
        playingSounds.splice(soundIndex, 1);
    }
    /**
     * Creates a new sound instance for the given audio source.
     * @param url - The path url to the audio file
     * @param properties - The properties of the sound
     * @param loadHandler - A handler for when the audio is loaded successfully or unsuccessfully
     * @param onEndHandler - A handler for when the sound finishes playing
     * @param onEndHandlerScope - The scope for the sound end handler
     * @returns A new sound instance
     */
    createSound(url, properties, loadHandler = null, onEndHandler = null, onEndHandlerScope = this) {
        let parameter = new SoundParameter();
        parameter.src = [url];
        parameter.autoplay = false;
        parameter.loop = properties.loop;
        parameter.onload = function () {
            if (loadHandler) {
                loadHandler.call();
            }
        };
        parameter.onloaderror = function () {
            if (loadHandler) {
                loadHandler.call();
            }
        };
        parameter.onend = function (soundId) {
            if (onEndHandler) {
                onEndHandler.call(onEndHandlerScope, soundId, properties);
            }
        };
        return new Sound(parameter);
    }
    getCachedSounds(name) {
        return this.getSounds(this.cachedSounds, name);
    }
    getPlayingSounds(name) {
        return this.getSounds(this.playingSounds, name);
    }
    getSounds(dictionary, name) {
        let sounds;
        if (dictionary.containsKey(name)) {
            sounds = dictionary.getValue(name);
        }
        else {
            sounds = [];
            dictionary.setValue(name, sounds);
        }
        return sounds;
    }
    isMuted() {
        return this.muted;
    }
}
//# sourceMappingURL=SoundChannel.js.map